import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const UserTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell />
        <TableCell sortDirection={orderBy === 'menuEventName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuEventName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuEventName');
            }}
          >
            イベント名
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuEventId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuEventId'}
            direction={order}
            onClick={() => {
              onRequestSort('menuEventId');
            }}
          >
            メニューID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'menuName'}
            direction={order}
            onClick={() => {
              onRequestSort('menuName');
            }}
          >
            メニュー名
          </TableSortLabel>
        </TableCell>
        <TableCell>チケット発行種別</TableCell>
        <TableCell sortDirection={orderBy === 'price' ? order : false}>
          <TableSortLabel
            active={orderBy === 'price'}
            direction={order}
            onClick={() => {
              onRequestSort('price');
            }}
          >
            価格
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'taxTypeStr' ? order : false}>
          <TableSortLabel
            active={orderBy === 'taxTypeStr'}
            direction={order}
            onClick={() => {
              onRequestSort('taxTypeStr');
            }}
          >
            税区分
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'premiumPercent' ? order : false}>
          <TableSortLabel
            active={orderBy === 'premiumPercent'}
            direction={order}
            onClick={() => {
              onRequestSort('premiumPercent');
            }}
          >
            プレミアム率
          </TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel>表示金額</TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'prefectures' ? order : false}>
          <TableSortLabel
            active={orderBy === 'prefectures'}
            direction={order}
            onClick={() => {
              onRequestSort('prefectures');
            }}
          >
            条件
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'createdAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'createdAt'}
            direction={order}
            onClick={() => {
              onRequestSort('createdAt');
            }}
          >
            作成日
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'updatedAt' ? order : false}>
          <TableSortLabel
            active={orderBy === 'updatedAt'}
            direction={order}
            onClick={() => {
              onRequestSort('updatedAt');
            }}
          >
            最新挿入日
          </TableSortLabel>
        </TableCell>
        <TableCell>&nbsp;&nbsp;&nbsp;表示</TableCell>
        <TableCell />
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(UserTableHead);
